import { useState, useEffect } from "react";
import { DownIcon, UpIcon } from "../../assets";
import { getDataSource } from "../../services/api";
import { formatGermanNumber, handleImageError } from "../../utils/common";
import { useTranslation } from "react-i18next";

const DeputyCard = ({ deputy, party, translation }) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const {
    deputyName,
    localMandate,
    deputyRegion,
    firstTimeElected,
    officeDuration,
    numberOfQuestions,
    questionSinceYear,
    participationPercentage,
    deputyImageUrl,
    gender,
  } = deputy;

  const [detailsVisible, setDetailsVisible] = useState(false);
  const transformedTranslation = translation.reduce((acc, obj) => {
    acc[obj.de] = obj;
    return acc;
  }, {});

  useEffect(() => {
    window.wort.frameResize();
  }, [detailsVisible]);

  const isDE = language === "de";
  const dataSeparator = isDE ? "." : "/";

  const excelDateToJSDate = (serial) => {
    if (serial) {
      var date = new Date((serial - 25569) * 86400000);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return day + dataSeparator + month + dataSeparator + year;
    }
    return "";
  };

  const formatDate = (value) => {
    if (typeof value === "number") {
      return excelDateToJSDate(firstTimeElected);
    } else {
      const parts = value.split("/");
      const newDateStr = `${parts[0]}${dataSeparator}${parts[1]}${dataSeparator}${parts[2]}`;
      return newDateStr;
    }
  };

  const isNotRunning = () => {
    if (
      deputyName === "Aly Kaes" ||
      deputyName === "Jean-Marie Halsdorf" ||
      deputyName === "Nathalie Oberweis"
    ) {
      return true;
    }
    return false;
  };

  return (
    <div className="mb-[4px] flex flex-col rounded bg-wort border border-transparent hover:border-gray-300 transition-all duration-300 group">
      <div className="flex flex-row">
        <img
          src={`${getDataSource()}/portraits-legislative/${party}/${deputyImageUrl}.webp`}
          alt={deputyName}
          onError={handleImageError}
          className="w-[48px] h-[48px] rounded-l-sm"
        />

        <div className="flex flex-col px-2 w-full">
          <div
            className="flex flex-row justify-between cursor-pointer"
            onClick={() => setDetailsVisible(!detailsVisible)}
          >
            <span className="ml-2 mt-2">{deputyName}</span>
            {detailsVisible ? (
              <UpIcon
                className="w-5 h-[11px] ml-2 mt-3"
                onClick={() => setDetailsVisible(false)}
              />
            ) : (
              <DownIcon
                className="w-5 h-[11px] ml-2 mt-3 transition-transform duration-300 group-hover:rotate-180"
                onClick={() => setDetailsVisible(true)}
              />
            )}
          </div>
          {detailsVisible && (
            <div className="h-0.5 bg-black bg-opacity-30 mt-[12px]"></div>
          )}
        </div>
      </div>
      {detailsVisible && (
        <div className="flex flex-col px-3 pt-4 pb-2" id="detail-section">
          <div>
            <span className="mt-2 text-sm">{t("electoralRegion")}: </span>
            <span className="mt-2 text-sm">
              {transformedTranslation[deputyRegion][language]}{" "}
              {localMandate
                ? " | " + transformedTranslation[localMandate][language]
                : ""}
            </span>
          </div>
          <div className="mt-3">
            <span className="mt-2">{t("deputyOne")}</span>
            <span className="ml-1 mt-2 font-semibold text-secondary">
              {formatDate(firstTimeElected)}
            </span>
            <span className="mt-2">
              {gender === "w" ? t("deputyEight") : t("deputyTwo")}
            </span>
            <span className="ml-1 mt-2 font-semibold text-secondary">
              {officeDuration ? officeDuration : 0}{" "}
              {`${officeDuration === 1 ? t("deputySeven") : t("deputySix")}`}
            </span>
            <span className="ml-1 mt-2">{t("deputyFive")}</span>
          </div>
          <div className="mt-2">
            <span className="mt-2 mr-1 font-semibold text-secondary">
              {numberOfQuestions}
            </span>
            <span className="mt-2">{t("deputyThree")}</span>
            <span className="ml-1 mt-2 font-semibold text-secondary">
              {questionSinceYear}
            </span>
          </div>
          <div className="mt-2">
            <span className="mt-2 font-semibold text-secondary">
              {isDE
                ? formatGermanNumber(participationPercentage) + "%"
                : participationPercentage + "%"}
            </span>
            <span className="ml-1 mt-2">{t("presenceRate")}</span>
          </div>
          {isNotRunning() && (
            <div className="mt-2">
              <span className="ml-1 mt-2">{t("isNotRunning")}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DeputyCard;
